module.exports = __webpack_public_path__ + "3d7e839223583b8cec543d319bdcef4f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-15.png
// module id = 3242
// module chunks = 0